import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const IS_PROD = import.meta.env.PROD;

const DASHBOARD: AppRouteRecordRaw = {
  path: '/dashboard',
  name: 'dashboard',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.dashboard',
    requiresAuth: true,
    icon: 'icon-bar-chart',
    order: 0,
    roles: ['admin', 'superAdmin'],
    hideInMenu: !IS_PROD,
  },
  children: [
    {
      path: 'overview',
      name: 'DashboardOverview',
      component: () => import('@/views/dashboard/overview/index.vue'),
      meta: {
        locale: 'menu.dashboard.overview',
        requiresAuth: true,
        roles: ['admin', 'superAdmin'],
        hideInMenu: !IS_PROD,
      },
    },
    {
      path: 'orders',
      name: 'DashboardOrders',
      component: () => import('@/views/dashboard/orders/index.vue'),
      meta: {
        locale: 'menu.dashboard.orders',
        requiresAuth: true,
        roles: ['admin', 'superAdmin'],
        hideInMenu: !IS_PROD,
      },
    },
    {
      path: 'subscriptions',
      name: 'DashboardSubscriptions',
      component: () => import('@/views/dashboard/subscriptions/index.vue'),
      meta: {
        locale: 'menu.dashboard.subscriptions',
        requiresAuth: true,
        roles: ['admin', 'superAdmin'],
        hideInMenu: !IS_PROD,
      },
    },
    {
      path: 'payment',
      name: 'DashboardPayment',
      component: () => import('@/views/dashboard/payment/index.vue'),
      meta: {
        locale: 'menu.dashboard.payment',
        requiresAuth: true,
        roles: ['admin', 'superAdmin'],
        hideInMenu: !IS_PROD,
      },
    },
    {
      path: 'data-analysis',
      name: 'DataAnalysis',
      component: () => import('@/views/visualization/data-analysis/index.vue'),
      meta: {
        locale: 'menu.visualization.dataAnalysis',
        requiresAuth: true,
        roles: ['admin'],
        hideInMenu: true,
      },
    },
    {
      path: 'multi-dimension-data-analysis',
      name: 'MultiDimensionDataAnalysis',
      component: () =>
        import('@/views/visualization/multi-dimension-data-analysis/index.vue'),
      meta: {
        locale: 'menu.visualization.multiDimensionDataAnalysis',
        requiresAuth: true,
        roles: ['admin'],
        hideInMenu: true,
      },
    },
  ],
};

export default DASHBOARD;
